import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import userManager, { signout } from "../../../utils/oidcUserManager";

/**
 * Pagina mostrata quando l'utente E' autenticato su Keycloak ma il suo claim
 * `available_app` non contiene questa applicazione (REACT_APP_NAME).
 *
 * Casi tipici:
 *  - sul PC c'e' una sessione SSO Keycloak di un ALTRO account (login automatico
 *    senza prompt): l'utente vede questa pagina senza capire con chi e' loggato;
 *  - il permesso e' stato assegnato DOPO il login: i claim in sessione sono vecchi.
 *
 * Per il secondo caso, al mount proviamo un `signinSilent()` (usa il refresh
 * token, nessun iframe): se i nuovi claim contengono l'app, store.js aggiorna
 * `auth.user` e Routes redirige a "/" da solo. Solo se il ricontrollo fallisce
 * o conferma la mancanza del permesso mostriamo il messaggio e il pulsante.
 */
function ChangeUser() {
  const user = useSelector((state) => state.auth.user);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    userManager
      .signinSilent()
      .catch((error) => {
        console.warn("Silent claims refresh failed", error);
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const onChangeUserClick = () => {
    signout();
  };

  return (
    <div className="login-form login-signin">
      <div className="text-center mb-10 mb-lg-20">
        {checking ? (
          <p className="text-muted">Verifica dei permessi in corso…</p>
        ) : (
          <>
            <h3 className="font-size-h1">Accesso non abilitato</h3>
            <p className="text-muted font-weight-bold">
              Sei autenticato come <strong>{user?.username || "utente sconosciuto"}</strong>,
              ma questo account non è abilitato all'utilizzo di questa applicazione.
            </p>
            <p className="text-muted">
              Se ritieni di avere i permessi, contatta l'amministratore oppure accedi con un altro utente.
            </p>
          </>
        )}
      </div>
      {!checking && (
        <div className="form-group row">
          <div className="col-lg-4"></div>
          <div className="col-lg-4 text-center">
            <button
              id="kt_login_signin_submit"
              onClick={onChangeUserClick}
              className={`btn btn-primary font-weight-bold px-4 py-4 my-3`}
            >
              Cambia utente
            </button>
          </div>
          <div className="col-lg-4"></div>
        </div>
      )}
    </div>
  );
}

export default ChangeUser;
